import "./Painel.css";
import React, { useState } from "react";
import { Link, useLocation, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import {
  FaHome,
  FaBuilding,
  FaUsers,
  FaUserFriends,
  FaUserTie,
  FaCalendarAlt,
  FaFileAlt,
  FaGavel,
  FaChartBar,
  FaSearch,
  FaClipboardList,
  FaBars,
  FaUserCircle,
  FaSignOutAlt,
  FaChevronDown,
  FaChevronUp,
  FaBalanceScale,
  FaVoteYea,
} from "react-icons/fa";

function Painel() {
  const { user, logout } = useAuth();
  const [showFloatingMenu, setShowFloatingMenu] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [openSections, setOpenSections] = useState({
    institucional: false,
    documentos: false,
    atividade: false,
  });
  const [atalhos, setAtalhos] = useState([]);

  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const toggleFloatingMenu = () => {
    setShowFloatingMenu(!showFloatingMenu);
    setShowOverlay(!showOverlay);
  };

  const closeMenu = () => {
    setShowFloatingMenu(false);
    setShowOverlay(false);
  };

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const isActive = (path) => {
    const currentPath = location.pathname.replace("/app", "");
    return (
      currentPath === `/painel${path}` ||
      currentPath.startsWith(`/painel${path}`)
    );
  };

  // Adicionar atalho ao clicar em um menu
  const adicionarAtalho = (submenu) => {
    // Verificar se já existe
    const existe = atalhos.some((a) => a.path === submenu.path);
    if (existe) return;

    setAtalhos((prev) => {
      const novaFila = [...prev, submenu];
      // Limitar a 5 atalhos
      return novaFila.slice(-5);
    });
    closeMenu();
  };

  // Menu completo conforme sua estrutura
  const menuItems = [
    {
      id: "inicio",
      name: "Início",
      path: "/",
      icon: <FaHome />,
      type: "single",
    },
    {
      id: "institucional",
      name: "Institucional",
      icon: <FaBuilding />,
      type: "group",
      submenus: [
        {
          name: "Mesa Diretora",
          path: "/institucional/mesa-diretora",
          icon: <FaUserTie />,
        },
        {
          name: "Bancada Parlamentares",
          path: "/institucional/bancada-parlamentares",
          icon: <FaUsers />,
        },
        {
          name: "Blocos Parlamentares",
          path: "/institucional/blocos-parlamentares",
          icon: <FaUserFriends />,
        },
        {
          name: "Comissões",
          path: "/institucional/comissoes",
          icon: <FaCalendarAlt />,
        },
        {
          name: "Frentes",
          path: "/institucional/frentes",
          icon: <FaUserFriends />,
        },
        {
          name: "Parlamentares",
          path: "/institucional/parlamentares",
          icon: <FaUserTie />,
        },
        {
          name: "Audiências Públicas",
          path: "/institucional/audiencias-publicas",
          icon: <FaUsers />,
        },
      ],
    },
    {
      id: "documentos",
      name: "Documentos Administrativos",
      icon: <FaFileAlt />,
      type: "group",
      submenus: [
        {
          name: "Pesquisar Documentos",
          path: "/documentos-administrativos/pesquisar",
          icon: <FaSearch />,
        },
      ],
    },
    {
      id: "atividade",
      name: "Atividade Legislativa",
      icon: <FaGavel />,
      type: "group",
      submenus: [
        {
          name: "Matérias Legislativas",
          path: "/atividade-legislativa/materias-legislativas",
          icon: <FaClipboardList />,
        },
        {
          name: "Pautas das Sessões",
          path: "/atividade-legislativa/pautas-sessoes",
          icon: <FaCalendarAlt />,
        },
        {
          name: "Relatórios",
          path: "/atividade-legislativa/relatorios",
          icon: <FaChartBar />,
        },
        {
          name: "Sessões Plenárias",
          path: "/atividade-legislativa/sessoes-plenarias",
          icon: <FaGavel />,
        },
        {
          name: "Votações",
          path: "/atividade-legislativa/votacoes",
          icon: <FaVoteYea />,
        },
      ],
    },
  ];

  // Icones para os atalhos
  const getIconForPath = (path) => {
    for (const menu of menuItems) {
      if (menu.type === "group") {
        const submenu = menu.submenus.find((s) => s.path === path);
        if (submenu) return submenu.icon;
      } else if (menu.path === path) {
        return menu.icon;
      }
    }
    return <FaFileAlt />;
  };

  return (
    <div className="painel-container">
      {/* Topbar Horizontal */}
      <div className="sidebar">
        {/* Botão do Menu */}
        <button className="toggle-btn" onClick={toggleFloatingMenu}>
          <FaBars />
        </button>

        {/* Atalhos dos últimos acessados */}
        <nav className="sidebar-menu">
          <ul>
            {atalhos.length === 0 ? (
              <li className="menu-placeholder">
                {/* Ícones padrão quando não há atalhos */}
                <Link
                  to="/painel/"
                  className={`submenu-icon-link ${isActive("/") ? "active" : ""}`}
                  title="Início"
                >
                  <FaHome />
                </Link>
              </li>
            ) : (
              atalhos.map((item) => (
                <li key={item.path}>
                  <Link
                    to={`/painel${item.path}`}
                    title={item.name}
                    className={`submenu-icon-link ${isActive(item.path) ? "active" : ""}`}
                  >
                    {getIconForPath(item.path)}
                  </Link>
                </li>
              ))
            )}
          </ul>
        </nav>

        {/* Botão de Logout */}
        <button className="logout-btn" onClick={logout} title="Sair">
          <FaSignOutAlt />
        </button>
      </div>

      {/* Overlay para fechar o menu ao clicar fora */}
      {showOverlay && (
        <div className="floating-menu-overlay" onClick={closeMenu} />
      )}

      {/* Floating Menu Lateral */}
      {showFloatingMenu && (
        <div className={`floating-menu ${showFloatingMenu ? "open" : ""}`}>
          {/* Menu Principal */}
          <div className="floating-menu-sections">
            {/* Início */}
            <div className="floating-menu-section">
              <div className="floating-menu-title">Menu Principal</div>
              <ul>
                <li>
                  <Link
                    to="/painel/"
                    className={isActive("/") ? "active" : ""}
                    onClick={() => {
                      adicionarAtalho({
                        path: "/",
                        name: "Início",
                        icon: <FaHome />,
                      });
                    }}
                  >
                    <span className="floating-menu-icon">
                      <FaHome />
                    </span>
                    <span className="floating-menu-label">Início</span>
                  </Link>
                </li>
              </ul>
            </div>

            {/* Institucional */}
            <div className="floating-menu-section">
              <div className="floating-menu-title">Institucional</div>
              <ul>
                {menuItems
                  .find((m) => m.id === "institucional")
                  ?.submenus.map((submenu) => (
                    <li key={submenu.path}>
                      <Link
                        to={`/painel${submenu.path}`}
                        className={isActive(submenu.path) ? "active" : ""}
                        onClick={() => adicionarAtalho(submenu)}
                      >
                        <span className="floating-menu-icon">
                          {submenu.icon}
                        </span>
                        <span className="floating-menu-label">
                          {submenu.name}
                        </span>
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>

            {/* Documentos Administrativos */}
            <div className="floating-menu-section">
              <div className="floating-menu-title">
                Documentos Administrativos
              </div>
              <ul>
                {menuItems
                  .find((m) => m.id === "documentos")
                  ?.submenus.map((submenu) => (
                    <li key={submenu.path}>
                      <Link
                        to={`/painel${submenu.path}`}
                        className={isActive(submenu.path) ? "active" : ""}
                        onClick={() => adicionarAtalho(submenu)}
                      >
                        <span className="floating-menu-icon">
                          {submenu.icon}
                        </span>
                        <span className="floating-menu-label">
                          {submenu.name}
                        </span>
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>

            {/* Atividade Legislativa */}
            <div className="floating-menu-section">
              <div className="floating-menu-title">Atividade Legislativa</div>
              <ul>
                {menuItems
                  .find((m) => m.id === "atividade")
                  ?.submenus.map((submenu) => (
                    <li key={submenu.path}>
                      <Link
                        to={`/painel${submenu.path}`}
                        className={isActive(submenu.path) ? "active" : ""}
                        onClick={() => adicionarAtalho(submenu)}
                      >
                        <span className="floating-menu-icon">
                          {submenu.icon}
                        </span>
                        <span className="floating-menu-label">
                          {submenu.name}
                        </span>
                      </Link>
                    </li>
                  ))}
              </ul>
            </div>

            {/* Sistema */}
            <div className="floating-menu-section">
              <div className="floating-menu-title">Sistema</div>
              <ul>
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      closeMenu();
                      logout();
                    }}
                  >
                    <span className="floating-menu-icon">
                      <FaSignOutAlt />
                    </span>
                    <span className="floating-menu-label">Sair</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* Conteúdo Principal */}
      <div className="main-content">
        <Outlet />
      </div>
    </div>
  );
}

export default Painel;